;(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("PopupModal-size-finder")
    if (!modal) return

    const RECOMMENDATION_NOTE =
      "Choose the shorter board for a more playful ride with quicker turns and greater maneuverability, or the longer board for added stability, control, and float."

    const els = {
      ddRoot: modal.querySelector("#boot-dd"),
      ddBtn: null,
      ddLabel: null,
      ddList: null,
      bootValueInput: modal.querySelector("#boot-value"),
      bootBindingInput: modal.querySelector("#boot-binding"),
      sizeFinderForm: modal.querySelector("#size-finder__form"),
      closeBtn: modal.querySelector("#close"),
      restartBtn: modal.querySelector("#restart"),
      weightInput: modal.querySelector("#weight"),
      unitSwitch: modal.querySelector(".unit-switch"),
      submitBtn: modal.querySelector("#submit"),
      contentInfo: modal.querySelector(".popup-modal__content-info"),
    }

    els.ddBtn = els.ddRoot?.querySelector(".dd__button") || null
    els.ddLabel = els.ddRoot?.querySelector(".dd__label") || null
    els.ddList = els.ddRoot?.querySelector(".dd__list") || null

    const ddItems = els.ddList ? Array.from(els.ddList.querySelectorAll(".dd__option")) : []

    const on = (el, evt, fn) => el && el.addEventListener(evt, fn)
    const setAria = (el, name, val) => el && el.setAttribute(name, String(val))
    const showBlock = el => {
      if (el) el.style.display = "block"
    }
    const showInline = el => {
      if (el) el.style.display = ""
    }
    const hideEl = el => {
      if (el) el.style.display = "none"
    }

    function hasEmptyCells() {
      const table = document.querySelector("#size-finder-data-table")
      if (!table) return false

      const cells = table.querySelectorAll("tbody td")
      return Array.from(cells).some(td => td.textContent.trim() === "")
    }

    function toggleModalOpener() {
      const opener = document.querySelector('modal-opener[data-modal="#PopupModal-size-finder"]')
      const dotSeparator = document.querySelector(".product-size-buttons .dot-separator")
      if (!opener) return

      const shouldHide = hasEmptyCells()
      opener.style.display = shouldHide ? "none" : ""
      if (dotSeparator) dotSeparator.style.display = shouldHide ? "none" : ""
    }

    let resultBox = modal.querySelector("#result")
    if (!resultBox) {
      resultBox = document.createElement("div")
      resultBox.id = "result"
      els.contentInfo?.appendChild(resultBox)
    }

    ;[els.closeBtn, els.restartBtn, els.submitBtn, resultBox, els.sizeFinderForm].forEach(el => {
      el?.removeAttribute?.("hidden")
    })

    function showFormState() {
      showInline(els.sizeFinderForm)
      showInline(els.submitBtn)
      hideEl(els.closeBtn)
      hideEl(els.restartBtn)
      hideEl(resultBox)
    }

    function showResultState() {
      hideEl(els.sizeFinderForm)
      hideEl(els.submitBtn)
      els.closeBtn?.removeAttribute("hidden")
      els.restartBtn?.removeAttribute("hidden")
      showBlock(els.closeBtn)
      showBlock(els.restartBtn)
    }

    showFormState()
    toggleModalOpener()

    function openDD() {
      setAria(els.ddRoot, "aria-expanded", "true")
      setAria(els.ddBtn, "aria-expanded", "true")
    }

    function closeDD() {
      setAria(els.ddRoot, "aria-expanded", "false")
      setAria(els.ddBtn, "aria-expanded", "false")
    }

    function toggleDD() {
      const expanded = els.ddRoot?.getAttribute("aria-expanded") === "true"
      if (expanded) closeDD()
      else openDD()
    }

    function selectDD(item) {
      if (!item || !els.bootValueInput) return

      ddItems.forEach(el => {
        el.removeAttribute("aria-current")
        el.setAttribute("aria-selected", el === item ? "true" : "false")
      })

      item.setAttribute("aria-current", "true")
      const text = item.textContent.trim()

      if (els.ddLabel) els.ddLabel.textContent = text
      els.bootValueInput.value = item.dataset.value || ""
      if (els.bootBindingInput) els.bootBindingInput.value = item.dataset.binding || ""

      els.bootValueInput.dispatchEvent(new Event("change", { bubbles: true }))
    }

    if (els.ddRoot && els.ddBtn && els.ddList) {
      on(els.ddBtn, "click", toggleDD)

      on(els.ddList, "click", e => {
        const item = e.target.closest(".dd__option")
        if (!item) return

        selectDD(item)
        closeDD()
        els.ddBtn.focus()
      })

      on(document, "click", e => {
        if (els.ddRoot && !els.ddRoot.contains(e.target)) closeDD()
      })

      on(els.ddBtn, "keydown", e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          toggleDD()
        }
      })

      on(els.ddList, "keydown", e => {
        const current = els.ddList.querySelector("[aria-current='true']")
        let index = ddItems.indexOf(current)

        if (e.key === "Escape") {
          e.preventDefault()
          closeDD()
          els.ddBtn.focus()
          return
        }

        if (e.key === "Enter") {
          e.preventDefault()
          selectDD(current || ddItems[0])
          closeDD()
          els.ddBtn.focus()
          return
        }

        if (e.key === "ArrowDown") {
          e.preventDefault()
          index = Math.min(index < 0 ? 0 : index + 1, ddItems.length - 1)
        }

        if (e.key === "ArrowUp") {
          e.preventDefault()
          index = Math.max(index < 0 ? 0 : index - 1, 0)
        }

        if (e.key === "Home") {
          e.preventDefault()
          index = 0
        }

        if (e.key === "End") {
          e.preventDefault()
          index = ddItems.length - 1
        }

        if (index >= 0) {
          ddItems.forEach(el => el.removeAttribute("aria-current"))
          ddItems[index].setAttribute("aria-current", "true")
          ddItems[index].scrollIntoView({ block: "nearest" })
        }
      })

      const preset = ddItems.find(el => el.getAttribute("aria-selected") === "true")
      if (preset) selectDD(preset)
    }

    function parseChart() {
      const table = modal.querySelector("#size-finder-data-table")
      if (!table) return []

      const headers = [...table.querySelectorAll("thead th")].map(th => th.textContent.trim())
      const sizes = headers.slice(1)
      const rows = [...table.querySelectorAll("tbody tr")]

      const rowMap = {}
      rows.forEach(row => {
        const cells = [...row.querySelectorAll("td")].map(td => td.textContent.trim())
        const key = cells[0]

        rowMap[key] = cells.slice(1).map(value => {
          const num = Number(value)
          return Number.isNaN(num) ? value : num
        })
      })

      return sizes.map((size, index) => ({
        size: size.toUpperCase(),
        boots_min: rowMap["boots_min_size"]?.[index],
        boots_max: rowMap["boots_max_size"]?.[index],
        weight_min_lbs: rowMap["min_weight"]?.[index],
        weight_max_lbs: rowMap["max_weight"]?.[index],
        comment: rowMap["comment"]?.[index],
      }))
    }

    const chart = parseChart()
    let unit = "lbs"

    on(els.unitSwitch, "click", e => {
      const btn = e.target.closest("button")
      if (!btn) return

      unit = btn.dataset.unit
      els.unitSwitch.querySelectorAll("button").forEach(button => {
        const active = button === btn
        button.classList.toggle("active", active)
        button.setAttribute("aria-selected", active ? "true" : "false")
      })
    })

    const kgToLbs = kg => Math.round(kg * 2.20462262)

    const bootSizes = [
      { us_men: 3.5, us_women: 5.0, eu: 35.0, mondo: 22.0, uk: 3.0, binding: "S" },
      { us_men: 4.0, us_women: 5.5, eu: 35.5, mondo: 22.5, uk: 3.5, binding: "S" },
      { us_men: 4.5, us_women: 6.0, eu: 36.0, mondo: 22.5, uk: 3.5, binding: "S" },
      { us_men: 5.0, us_women: 6.5, eu: 36.5, mondo: 23.0, uk: 4.0, binding: "S" },
      { us_men: 5.0, us_women: 6.5, eu: 37.0, mondo: 23.0, uk: 4.0, binding: "S" },
      { us_men: 5.5, us_women: 7.0, eu: 37.5, mondo: 23.5, uk: 4.5, binding: "S" },
      { us_men: 6.0, us_women: 7.5, eu: 38.0, mondo: 24.0, uk: 5.0, binding: "S" },
      { us_men: 6.5, us_women: 8.0, eu: 38.5, mondo: 24.5, uk: 5.5, binding: "S" },
      { us_men: 6.5, us_women: 8.0, eu: 39.0, mondo: 24.5, uk: 5.5, binding: "S" },
      { us_men: 7.0, us_women: 8.5, eu: 39.5, mondo: 25.0, uk: 6.0, binding: "S" },
      { us_men: 7.5, us_women: 9.0, eu: 40.0, mondo: 25.5, uk: 6.5, binding: "M" },
      { us_men: 8.0, us_women: 9.5, eu: 40.5, mondo: 26.0, uk: 7.0, binding: "M" },
      { us_men: 8.0, us_women: 9.5, eu: 41.0, mondo: 26.0, uk: 7.0, binding: "M" },
      { us_men: 8.5, us_women: 10.0, eu: 41.5, mondo: 26.5, uk: 7.5, binding: "M" },
      { us_men: 9.0, us_women: 10.5, eu: 42.0, mondo: 27.0, uk: 8.0, binding: "M" },
      { us_men: 9.5, us_women: 11.0, eu: 42.5, mondo: 27.5, uk: 8.5, binding: "M" },
      { us_men: 10.0, us_women: null, eu: 43.0, mondo: 28.0, uk: 9.0, binding: "M" },
      { us_men: 10.5, us_women: null, eu: 43.5, mondo: 28.5, uk: 9.5, binding: "L" },
      { us_men: 10.5, us_women: null, eu: 44.0, mondo: 28.5, uk: 9.5, binding: "L" },
      { us_men: 11.0, us_women: null, eu: 44.5, mondo: 29.0, uk: 10.0, binding: "L" },
      { us_men: 11.5, us_women: null, eu: 45.0, mondo: 29.5, uk: 10.5, binding: "L" },
      { us_men: 12.0, us_women: null, eu: 45.5, mondo: 30.0, uk: 11.0, binding: "L" },
      { us_men: 12.5, us_women: null, eu: 46.0, mondo: 30.5, uk: 11.5, binding: "L" },
      { us_men: 13.0, us_women: null, eu: 46.5, mondo: 31.0, uk: 12.0, binding: "L" },
      { us_men: 13.0, us_women: null, eu: 47.0, mondo: 31.0, uk: 12.0, binding: "L" },
      { us_men: 13.5, us_women: null, eu: 47.5, mondo: 31.5, uk: 12.5, binding: "L" },
      { us_men: 14.0, us_women: null, eu: 48.0, mondo: 31.5, uk: 13.0, binding: "L" },
      { us_men: 14.0, us_women: null, eu: 48.5, mondo: 31.5, uk: 13.0, binding: "L" },
      { us_men: 15.0, us_women: null, eu: 50.0, mondo: 32.0, uk: 13.0, binding: "L" },
    ]

    function bindingForUSMen(us) {
      const exact = bootSizes.find(boot => boot.us_men === us)
      if (exact) return exact.binding

      const eligible = bootSizes.filter(boot => boot.us_men != null && boot.us_men <= us)
      if (!eligible.length) return null

      eligible.sort((a, b) => b.us_men - a.us_men)
      return eligible[0].binding || null
    }

    function sortSizes(a, b) {
      const leftNumber = parseInt(a, 10)
      const rightNumber = parseInt(b, 10)
      if (leftNumber !== rightNumber) return leftNumber - rightNumber

      const leftWide = /W$/i.test(a)
      const rightWide = /W$/i.test(b)
      if (leftWide === rightWide) return 0
      return leftWide ? 1 : -1
    }

    function listWithOr(list) {
      if (list.length <= 1) return list[0] || ""
      if (list.length === 2) return `${list[0]} or ${list[1]}`
      return `${list.slice(0, -1).join(", ")} or ${list[list.length - 1]}`
    }

    function pickDisplaySizes(sizes) {
      const total = sizes.length
      if (total <= 2) return sizes
      if (total === 3) return sizes.slice(0, 2)

      const left = Math.floor(total / 2) - 1
      const right = Math.floor(total / 2)
      return [sizes[left], sizes[right]]
    }

    function renderIncompleteFields() {
      showBlock(resultBox)
      resultBox.innerHTML = `<h3>Please complete both fields.</h3>`
    }

    function renderNoMatch() {
      showBlock(resultBox)
      resultBox.innerHTML = `
        <h3>No exact match found</h3>
        <div class="sf-note">
          Try adjusting your weight or boot size slightly. If you’re between sizes,
          a shorter board turns quicker; a longer board offers better float & stability.
        </div>
      `
    }

    function renderMatch({ displaySizes, selectedComment, binding }) {
      const isEitherWay = displaySizes.length > 1
      const title = isEitherWay
        ? `You could go either way: <span class="sizes">${listWithOr(displaySizes)}</span>`
        : `We recommend: <span class="sizes">${displaySizes[0]}</span>`

      showBlock(resultBox)
      resultBox.innerHTML = `
        <h3>${title}</h3>
        ${selectedComment ? `<div class="sf-note">${selectedComment}</div>` : ``}
        ${isEitherWay ? `<div class="sf-note chooseShorter">${RECOMMENDATION_NOTE}</div>` : ``}
        ${
          binding
            ? `<div class="sf-note">Bindings recommendation: Size <strong>${binding}</strong></div>`
            : ``
        }
      `
    }

    function compute() {
      const bootUS = parseFloat(els.bootValueInput?.value || "")
      const rawWeight = parseFloat(els.weightInput?.value || "")

      if (Number.isNaN(bootUS) || Number.isNaN(rawWeight)) {
        renderIncompleteFields()
        return
      }

      showResultState()

      const weightLbs = unit === "kg" ? kgToLbs(rawWeight) : Math.round(rawWeight)

      const matches = chart.filter(
        row =>
          bootUS >= row.boots_min &&
          bootUS <= row.boots_max &&
          weightLbs >= row.weight_min_lbs &&
          weightLbs <= row.weight_max_lbs
      )

      if (!matches.length) {
        renderNoMatch()
        return
      }

      const allSizes = [...new Set(matches.map(match => match.size))].sort(sortSizes)
      const displaySizes = pickDisplaySizes(allSizes)

      const selectedComment =
        displaySizes
          .map(size => matches.find(match => match.size === size)?.comment)
          .find(Boolean) || ""

      const binding = bindingForUSMen(bootUS)

      renderMatch({ displaySizes, selectedComment, binding })
    }

    on(els.submitBtn, "click", compute)

    on(els.weightInput, "keydown", e => {
      if (e.key === "Enter") {
        e.preventDefault()
        compute()
      }
    })

    on(els.closeBtn, "click", () => {
      if (typeof modal.hide === "function") modal.hide()
      else modal.removeAttribute("open")
    })

    on(els.restartBtn, "click", () => {
      showFormState()
    })
  })
})()
